import React from 'react';
import {Dialog as MaterialDialog, DialogTitle, DialogContent, DialogActions} from '@material-ui/core';


/************************ تکمیل نشده **********************************/

class Dialog extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {children, open, title, footer, width} = this.props;

        return (
            <MaterialDialog open={open} fullWidth maxWidth={width || 'xs'} scroll="body">
                <DialogTitle id="form-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent className='text-right'>
                    {children}
                </DialogContent>
                <DialogActions>
                    {footer}
                </DialogActions>
            </MaterialDialog>
        );
    }
}

export default Dialog;
